import {
	ChargesCategory,
	type ChargesUnitDetail,
	type ChargesUnitListItem,
	type FinancialPropertyListItem,
	type RevenueUnitDetail,
	type RevenueUnitListItem,
	type ServicePeriodListItem,
	ServicePeriodStatus,
	UnitPayoutStatus,
} from "./financialManagement.types";

export const REVENUE_PROPERTIES: FinancialPropertyListItem[] = [
	{
		id: "prop-oo-mandarina",
		name: "One&Only Mandarina",
		totalUnits: 48,
		latestServicePeriodLabel: "Jan 15, 2026 – Mar 15, 2026",
		status: ServicePeriodStatus.PUBLISHED,
		lastUpdatedDate: "Feb 15, 2026",
		approver: "Sarah Johnson",
	},
	{
		id: "prop-siro-boka",
		name: "SIRO Boka Place",
		totalUnits: 32,
		latestServicePeriodLabel: "Oct 1, 2025 – Dec 31, 2025",
		status: ServicePeriodStatus.COMPLETED,
		lastUpdatedDate: "Feb 12, 2026",
		approver: "Michael Chen",
	},
	{
		id: "prop-atlantis",
		name: "Atlantis The Royal",
		totalUnits: 52,
		latestServicePeriodLabel: "Jan 1, 2026 – Mar 31, 2026",
		status: ServicePeriodStatus.DRAFT,
		lastUpdatedDate: "Feb 8, 2026",
		approver: "Sarah Johnson",
	},
	{
		id: "prop-four-seasons",
		name: "Four Seasons Resort Dubai",
		totalUnits: 24,
		latestServicePeriodLabel: "Apr 1, 2026 – Jun 30, 2026",
		status: ServicePeriodStatus.PUBLISHED,
		lastUpdatedDate: "Feb 5, 2026",
		approver: "Ayush Mehta",
	},
];

export const CHARGES_PROPERTIES: FinancialPropertyListItem[] = [
	{
		id: "prop-oo-mandarina",
		name: "One&Only Mandarina",
		totalUnits: 48,
		latestServicePeriodLabel: "Jan 15, 2026 – Mar 15, 2026",
		chargesCategory: ChargesCategory.COMMON_AREA,
		status: ServicePeriodStatus.PUBLISHED,
		lastUpdatedDate: "Feb 15, 2026",
		approver: "Sarah Johnson",
	},
	{
		id: "prop-siro-boka",
		name: "SIRO Boka Place",
		totalUnits: 32,
		latestServicePeriodLabel: "Oct 1, 2025 – Dec 31, 2025",
		chargesCategory: ChargesCategory.UTILITIES,
		status: ServicePeriodStatus.COMPLETED,
		lastUpdatedDate: "Feb 12, 2026",
		approver: "Michael Chen",
	},
	{
		id: "prop-atlantis",
		name: "Atlantis The Royal",
		totalUnits: 52,
		latestServicePeriodLabel: "Jan 1, 2026 – Mar 31, 2026",
		chargesCategory: ChargesCategory.MANDATORY,
		status: ServicePeriodStatus.DRAFT,
		lastUpdatedDate: "Feb 8, 2026",
		approver: "Sarah Johnson",
	},
	{
		id: "prop-jumeirah",
		name: "Jumeirah Al Naseem",
		totalUnits: 36,
		latestServicePeriodLabel: "Apr 1, 2026 – Jun 30, 2026",
		chargesCategory: ChargesCategory.COMMON_AREA,
		status: ServicePeriodStatus.PUBLISHED,
		lastUpdatedDate: "Feb 3, 2026",
		approver: "Ayush Mehta",
	},
];

const SERVICE_PERIODS: ServicePeriodListItem[] = [
	{
		id: "period-oct-dec-25",
		propertyId: "prop-oo-mandarina",
		periodLabel: "Oct 25, 2025 – Dec 25, 2025",
		dueDate: "Jan 10, 2026",
		paidUnitsLabel: "28/32",
		status: ServicePeriodStatus.PUBLISHED,
		createdDate: "Jan 12, 2026",
		lastUpdatedBy: "Sarah Johnson",
		lastUpdatedDate: "Feb 10, 2026",
		approver: "Sarah Johnson",
		uploadedAtLabel: "Uploaded Feb 10, 2026 by Sarah Johnson",
	},
	{
		id: "period-jan-mar-26",
		propertyId: "prop-oo-mandarina",
		periodLabel: "Jan 15, 2026 – Mar 15, 2026",
		dueDate: "Mar 20, 2026",
		paidUnitsLabel: "16/32",
		status: ServicePeriodStatus.COMPLETED,
		createdDate: "Jan 20, 2026",
		lastUpdatedBy: "Michael Chen",
		lastUpdatedDate: "Feb 8, 2026",
		approver: "Michael Chen",
		uploadedAtLabel: "Uploaded Feb 8, 2026 by Michael Chen",
	},
	{
		id: "period-apr-jun-26",
		propertyId: "prop-oo-mandarina",
		periodLabel: "Apr 1, 2026 – Jun 1, 2026",
		dueDate: "Jun 15, 2026",
		paidUnitsLabel: "5/6",
		status: ServicePeriodStatus.PUBLISHED,
		createdDate: "Feb 1, 2026",
		lastUpdatedBy: "Sarah Johnson",
		lastUpdatedDate: "Feb 5, 2026",
		approver: "Sarah Johnson",
		uploadedAtLabel: "Uploaded Feb 5, 2026 by Sarah Johnson",
	},
	{
		id: "period-q4-25",
		propertyId: "prop-siro-boka",
		periodLabel: "Oct 1, 2025 – Dec 31, 2025",
		dueDate: "Jan 15, 2026",
		paidUnitsLabel: "30/32",
		status: ServicePeriodStatus.COMPLETED,
		createdDate: "Jan 5, 2026",
		lastUpdatedBy: "Michael Chen",
		lastUpdatedDate: "Feb 1, 2026",
		approver: "Michael Chen",
		uploadedAtLabel: "Uploaded Feb 1, 2026 by Michael Chen",
	},
];

const REVENUE_UNITS: RevenueUnitListItem[] = [
	{
		id: "unit-v50",
		unitCode: "V-50",
		ownerName: "Mr Zahir Moossa",
		ownerEmail: "zahir.moossa@example.com",
		nights: 42,
		netRevenue: 862192,
		ownerShare: 431096,
		balanceToPay: null,
		payoutMethod: "Bank Transfer",
		status: UnitPayoutStatus.SETTLED,
		isPaid: true,
	},
	{
		id: "unit-v51",
		unitCode: "V-51",
		ownerName: "Olivia Martinez",
		ownerEmail: "olivia.martinez@example.com",
		nights: 28,
		netRevenue: 520000,
		ownerShare: 260000,
		balanceToPay: 45000,
		payoutMethod: "Cheque",
		status: UnitPayoutStatus.IN_PROGRESS,
	},
	{
		id: "unit-v52",
		unitCode: "V-52",
		ownerName: "James Wilson",
		ownerEmail: "james.wilson@example.com",
		nights: 15,
		netRevenue: 310000,
		ownerShare: 155000,
		balanceToPay: 155000,
		payoutMethod: "Bank Transfer",
		status: UnitPayoutStatus.HOLD,
	},
	{
		id: "unit-v53",
		unitCode: "V-53",
		ownerName: "Aisha Khan",
		ownerEmail: "aisha.khan@example.com",
		nights: 35,
		netRevenue: 680000,
		ownerShare: 340000,
		balanceToPay: null,
		payoutMethod: "Bank Transfer",
		status: UnitPayoutStatus.SETTLED,
		isPaid: true,
	},
];

const CHARGES_UNITS: ChargesUnitListItem[] = [
	{
		id: "unit-v101",
		unitCode: "V-101",
		ownerName: "Olivia Martinez",
		ownerEmail: "olivia.martinez@example.com",
		amount: 1050,
		partialPayment: null,
		remainingLabel: "Fully Paid",
		isFullyPaid: true,
		paymentMethod: "App",
		status: UnitPayoutStatus.SETTLED,
	},
	{
		id: "unit-v102",
		unitCode: "V-102",
		ownerName: "James Wilson",
		ownerEmail: "james.wilson@example.com",
		amount: 1575,
		partialPayment: 500,
		remainingLabel: "AED 1,075",
		isFullyPaid: false,
		paymentMethod: "Bank Transfer",
		status: UnitPayoutStatus.PARTIALLY_PAID,
	},
	{
		id: "unit-v103",
		unitCode: "V-103",
		ownerName: "Aisha Khan",
		ownerEmail: "aisha.khan@example.com",
		amount: 2100,
		partialPayment: null,
		remainingLabel: "AED 2,100",
		isFullyPaid: false,
		paymentMethod: "Cheque",
		status: UnitPayoutStatus.PAST_DUE,
	},
	{
		id: "unit-v104",
		unitCode: "V-104",
		ownerName: "Mr Zahir Moossa",
		ownerEmail: "zahir.moossa@example.com",
		amount: 1575,
		partialPayment: null,
		remainingLabel: "Fully Paid",
		isFullyPaid: true,
		paymentMethod: "Bank Transfer",
		status: UnitPayoutStatus.SETTLED,
	},
];

const REVENUE_UNIT_DETAILS: Record<string, RevenueUnitDetail> = {
	"unit-v50": {
		id: "unit-v50",
		propertyId: "prop-oo-mandarina",
		periodId: "period-oct-dec-25",
		statementId: "RS-1001",
		unitCode: "V-50",
		ownerName: "Mr Zahir Moossa",
		ownerInitials: "ZM",
		ownerPhone: "+971 50 123 4567",
		ownerEmail: "zahir.moossa@example.com",
		unitDetail: "One&Only Mandarina · V-50 · 3B",
		status: UnitPayoutStatus.SETTLED,
		servicePeriodLabel: "Oct 25, 2025 – Dec 25, 2025",
		statementDate: "Feb 10, 2026",
		payoutDate: "Feb 5, 2026",
		totalAmountToTransfer: 181464,
		rentalActivityRows: [
			{
				id: "ra-1",
				period: "Oct 2025",
				unit: "V-50",
				type: "Rental",
				arrival: "Oct 5, 2025",
				departure: "Oct 18, 2025",
				resvNights: 13,
				netRoomRevenue: 431096,
			},
			{
				id: "ra-2",
				period: "Nov 2025",
				unit: "V-50",
				type: "Rental",
				arrival: "—",
				departure: "—",
				resvNights: "—",
				netRoomRevenue: "—",
			},
			{
				id: "ra-3",
				period: "Dec 2025",
				unit: "V-50",
				type: "Rental",
				arrival: "—",
				departure: "—",
				resvNights: "—",
				netRoomRevenue: "—",
			},
		],
		rentalSummaryRows: [
			{
				id: "rs-1",
				lineItem: "Rental Nights",
				oct: 13,
				nov: "—",
				dec: "—",
				total: 13,
			},
			{
				id: "rs-2",
				lineItem: "Gross Room Rental Revenue",
				oct: 500000,
				nov: "—",
				dec: "—",
				total: 500000,
			},
			{
				id: "rs-3",
				lineItem: "(-) VAT 15%",
				oct: -75000,
				nov: "—",
				dec: "—",
				total: -75000,
				isDeduction: true,
			},
			{
				id: "rs-4",
				lineItem: "(-) Environment Protection Fee 0.85%",
				oct: -4250,
				nov: "—",
				dec: "—",
				total: -4250,
				isDeduction: true,
			},
			{
				id: "rs-5",
				lineItem: "Net Room Rental Revenue",
				oct: 431096,
				nov: "—",
				dec: "—",
				total: 431096,
				isSubtotal: true,
			},
			{
				id: "rs-6",
				lineItem: "Total Amount to Transfer",
				oct: 181464,
				nov: "—",
				dec: "—",
				total: 181464,
				isGrandTotal: true,
			},
		],
	},
};

const CHARGES_UNIT_DETAILS: Record<string, ChargesUnitDetail> = {
	"unit-v101": {
		id: "unit-v101",
		propertyId: "prop-oo-mandarina",
		periodId: "period-jan-mar-26",
		invoiceNumber: "INV-1001",
		unitCode: "V-101",
		ownerName: "Olivia Martinez",
		ownerInitials: "OM",
		ownerPhone: "+971 55 987 6543",
		ownerEmail: "olivia.martinez@example.com",
		unitDetail: "One&Only Mandarina · V-101",
		status: UnitPayoutStatus.SETTLED,
		servicePeriodLabel: "Jan 15, 2026 – Mar 15, 2026",
		invoiceDate: "Feb 10, 2026",
		paymentDate: "Feb 5, 2026",
		totalAmount: 1575,
		lineItems: [
			{
				category: "Common Area Charges",
				description: "Utilities & Insurance",
				amount: 500,
				tax: 25,
				total: 525,
			},
			{
				category: "Common Area Charges",
				description: "Administrative Charges",
				amount: 500,
				tax: 25,
				total: 525,
			},
			{
				category: "Mandatory Services",
				description: "Administrative Costs",
				amount: 500,
				tax: 25,
				total: 525,
			},
		],
	},
};

export function getRevenueProperties(): FinancialPropertyListItem[] {
	return [...REVENUE_PROPERTIES];
}

export function getChargesProperties(): FinancialPropertyListItem[] {
	return [...CHARGES_PROPERTIES];
}

export function getPropertyById(
	id: string,
	module: "revenue" | "charges",
): FinancialPropertyListItem | undefined {
	const list = module === "revenue" ? REVENUE_PROPERTIES : CHARGES_PROPERTIES;
	return list.find((p) => p.id === id);
}

export function getServicePeriodsByProperty(
	propertyId: string,
): ServicePeriodListItem[] {
	return SERVICE_PERIODS.filter((p) => p.propertyId === propertyId);
}

export function getServicePeriodById(
	periodId: string,
): ServicePeriodListItem | undefined {
	return SERVICE_PERIODS.find((p) => p.id === periodId);
}

export function getRevenueUnitsByPeriod(
	_periodId: string,
): RevenueUnitListItem[] {
	return [...REVENUE_UNITS];
}

export function getChargesUnitsByPeriod(
	_periodId: string,
): ChargesUnitListItem[] {
	return [...CHARGES_UNITS];
}

export function getRevenueUnitDetail(
	unitId: string,
): RevenueUnitDetail | undefined {
	return REVENUE_UNIT_DETAILS[unitId];
}

export function getChargesUnitDetail(
	unitId: string,
): ChargesUnitDetail | undefined {
	return CHARGES_UNIT_DETAILS[unitId];
}

export function getPropertyOptionsForModal(): {
	value: string;
	label: string;
}[] {
	return REVENUE_PROPERTIES.map((p) => ({ value: p.id, label: p.name }));
}
